import { useDataChange, useDataValue } from 'Simple/Data.js'
import { useEffect, useCallback } from 'react'
import View from './view.js'
import query from './query-get-document-templates.graphql.js'
import { useClient } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'

export default function Logic(props) {
  let client = useClient()
  let change = useDataChange({
    context: 'modal',
    viewPath: props.viewPath,
  })
  let current_location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })
  let [, notify] = useNotifications()

  let resolveLetters = useCallback(
    async letters => {
      let templates = null
      let resolved_letters = []

      async function findTemplate(name) {
        if (!templates) {
          let { data, error } = await client
            .query(query, { org_id: current_location_id })
            .toPromise()
          if (error) {
            throw error
          }

          templates = data?.documents_get_document_templates_for_org || []
        }

        return templates.find(t => t.name === name)
      }

      for (let letter of letters) {
        if (letter.document_template_name) {
          let { document_template_name, ...rest_letter } = letter

          let template = await findTemplate(document_template_name)

          if (template) {
            resolved_letters.push({
              template_id: template.id,
              ...rest_letter,
            })
          } else {
            notify(
              notifyError(
                `Document template "${document_template_name}" not found.`
              )
            )
          }
        }
      }

      return resolved_letters
    },
    [client, current_location_id]
  ) // eslint-disable-line

  useEffect(() => {
    if (props.letters?.length) {
      resolveLetters(props.letters)
        .then(resolved_letters => {
          if (resolved_letters.length) {
            change(next => {
              next.letters.push(...resolved_letters)
            })
          }
        })
        .catch(console.error)
    }
  }, [props.letters, resolveLetters]) // eslint-disable-line

  useEffect(() => {
    change(next => {
      next.letter_params.patient_id = props.patientId
      next.letter_params.appointment_id = props.appointmentId
      next.letter_params.booking_id = props.bookingId
    })
  }, [props.appointmentId, props.bookingId, props.patientId]) // eslint-disable-line

  return <View {...props} />
}
